// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Chakra/ChakraPetch-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Chakra';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 600;
  font-style: normal;
}
.hud_prbar {
  display: flex;
  justify-content: center;
  text-align: center;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  user-select: none;
}
.hud_sp {
  display: flex;
  position: absolute;
  right: 0;
  bottom: 0;
  justify-content: flex-end;
  align-items: flex-end;
  width: 50vh;
  height: 50vh;
  overflow: hidden;
  z-index: -1;
  user-select: none;
  pointer-events: none;
}
.hud_sp .hud_bg {
  z-index: -1;
  position: absolute;
  background: radial-gradient(#060a103f, #ffffff00);
  opacity: 0.2;
  min-width: 30vh;
  min-height: 30vh;
}
.hud_sp .hud_circle {
  position: absolute;
  width: 30vh;
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.hud_sp .hud_circle .RCP__track {
  opacity: 0.5;
}
.hud_sp .hud_circle h1 {
  margin-top: -2vh;
  position: absolute;
  text-align: center;
  display: flex;
  color: #fff;
  font-family: Chakra;
  font-style: normal;
  font-weight: bold;
  font-size: 5vh;
  line-height: 100%;
  transition: all 1s ease;
  background: radial-gradient(#060a100f, #ffffff00);
}
.hud_sp .hud_circle h2 {
  position: absolute;
  text-align: center;
  display: flex;
  color: #ffffffbb;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 1.5vh;
  transition: all 1s ease;
  background: radial-gradient(#060a100f, #ffffff00);
  margin-top: -7.9vh;
}
.hud_sp .hud_circle .hud_s_data_left {
  position: absolute;
  margin-right: 23vh;
  margin-top: 23vh;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: all 1s ease-out;
}
.hud_sp .hud_circle .hud_s_data_left img {
  width: 2vh;
  background-color: rgba(84, 255, 84, 0.172);
  padding: 0.5vh;
  border-radius: 2vh;
  opacity: 0.3;
}
.hud_sp .hud_circle .hud_s_data_right {
  position: absolute;
  margin-right: -23vh;
  margin-top: 23vh;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: all 1s ease-out;
}
.hud_sp .hud_circle .hud_s_data_right img {
  width: 2vh;
  background-color: rgba(248, 142, 61, 0.172);
  padding: 0.5vh;
  border-radius: 2vh;
  opacity: 0.3;
}
.hud_sp .hud_circle .hud_s_data {
  position: absolute;
  margin-top: 23vh;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: all 1s ease-out;
}
.hud_sp .hud_circle .hud_s_data img {
  margin: 0.5vh;
  width: 2vh;
  background-color: rgba(84, 255, 84, 0.172);
  padding: 0.5vh;
  border-radius: 2vh;
  opacity: 0.3;
}
.hud_sp .hud_circle .hud_status_stack {
  position: absolute;
  margin-top: 8.9vh;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 0.65vh;
  width: 100%;
  left: 0;
}
.hud_sp .hud_circle .hud_status_stack .hud_status_bar {
  width: 14.5vh;
}
.hud_sp .hud_circle .hud_status_stack .hud_status_bar .hud_status_head {
  display: flex;
  align-items: center;
  justify-content: center;
}
.hud_sp .hud_circle .hud_status_stack .hud_status_bar .hud_status_head img {
  width: 1.45vh;
  opacity: 0.9;
  margin-right: 0.55vh;
}
.hud_sp .hud_circle .hud_status_stack .hud_status_bar .hud_status_head span {
  color: #ffffef;
  font-family: Chakra;
  font-style: normal;
  font-weight: bold;
  font-size: 1.45vh;
  line-height: 100%;
  letter-spacing: 0.02vh;
  text-shadow: 0 0 0.8vh rgba(6, 10, 16, 0.42);
}
.hud_sp .hud_circle .hud_status_stack .hud_status_bar .hud_status_track {
  margin-top: 0.35vh;
  width: 100%;
  height: 0.64vh;
  border-radius: 1vh;
  background: rgba(255, 255, 255, 0.2);
  overflow: hidden;
}
.hud_sp .hud_circle .hud_status_stack .hud_status_bar .hud_status_track div {
  height: 100%;
  border-radius: 1vh;
  transition: width 0.35s ease-out;
}
.hud_sp .hud_circle .RCP {
  position: absolute !important;
}
.hud_main {
  display: flex;
  position: absolute;
  right: 0;
  top: 0;
  justify-content: flex-end;
  align-items: flex-start;
  width: 45vh;
  height: 40vh;
  overflow: hidden;
  z-index: -1;
  user-select: none;
  pointer-events: none;
}
.hud_main .hud_bg {
  z-index: -1;
  position: absolute;
  background: radial-gradient(100% 100% at 100% 100%, #060A10 0%, #ffffff00 100%);
  opacity: 0.4;
  transform: matrix(1, 0, 0, -1, 0, 0);
  width: 34vh;
  height: 28vh;
}
.hud_main .hud_data {
  overflow: hidden;
  margin-right: 1vh;
  margin-top: 1vh;
}
.hud_main .hud_data .hud_sati {
  height: 4vh;
  margin-top: 1.5vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.hud_main .hud_data .hud_sati img {
  height: 3vh;
  animation: 0.5s linear 15s infinite alternate sati_frames;
}
@keyframes sati_frames {
  100% {
    height: 3.2vh;
  }
}
.hud_main .hud_data .hud_star {
  margin-top: 1.5vh;
  display: flex;
  justify-content: flex-end;
}
.hud_main .hud_data .hud_star img {
  height: 2vh;
}
.hud_main .hud_data .hud_bar {
  margin-top: 1vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.hud_main .hud_data .hud_bar img {
  height: 1.5vh;
  margin-right: 0.5vh;
}
.hud_main .hud_data .hud_bar h1 {
  min-width: 2vh;
  color: #FFFFFF;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 1.3vh;
  line-height: 100%;
  text-align: end;
}
.hud_main .hud_data .hud_bar .hud_hp {
  margin: 0 0.5vh;
  width: 12vh;
  height: 1.1vh;
  border-radius: 1vh;
}
.hud_main .hud_data .hud_bar .hud_hp div {
  height: 100%;
  border-radius: 1vh;
  transition: all 1s ease-out;
}
.hud_main .hud_data .hud_money {
  margin-top: 1vh;
  color: #fafff8;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 3vh;
  line-height: 100%;
  text-align: end;
}
.hud_main .hud_data .hud_server {
  display: flex;
  height: 5vh;
}
.hud_main .hud_data .hud_server .hud_time {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  height: 5vh;
  min-width: 5.5vh;
}
.hud_main .hud_data .hud_server .hud_time h1 {
  color: #FFFFFF;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 1.8vh;
  line-height: 100%;
}
.hud_main .hud_data .hud_server .hud_time div {
  display: flex;
  padding-top: 0.5vh;
}
.hud_main .hud_data .hud_server .hud_time div img {
  height: 1.3vh;
  margin-right: 0.5vh;
}
.hud_main .hud_data .hud_server .hud_time div h1 {
  color: #FFFFFF;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 1.7vh;
  line-height: 100%;
}
.hud_main .hud_data .hud_server .hud_server_left {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 5vh;
  position: relative;
  margin-right: 2vh;
}
.hud_main .hud_data .hud_server .hud_server_left img {
  height: 5vh;
  margin-right: 0.3vh;
}
.hud_main .hud_data .hud_server .hud_server_left .hud_server_center {
  display: flex;
  flex-direction: column;
}
.hud_main .hud_data .hud_server .hud_server_left .hud_server_center h1 {
  color: #fff;
  font-family: Chakra;
  font-size: 2vh;
}
.hud_main .hud_data .hud_server .hud_server_left .hud_server_center h2 {
  font-family: Chakra;
  font-style: normal;
  font-weight: 800;
  font-size: 2vh;
  line-height: 100%;
}
.hud_main .hud_data .hud_server .hud_server_left .hud_server_center div {
  display: flex;
}
.hud_main .hud_data .hud_server .hud_server_left .hud_server_center div img {
  height: 1.3vh;
  margin-right: 0.5vh;
}
.hud_main .hud_data .hud_server .hud_server_left .hud_server_center div h1 {
  color: #FFFFFF;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 1.7vh;
  line-height: 100%;
}
.hud_main .hud_weap {
  margin-top: 6.5vh;
  right: 20vh;
  position: absolute;
}
.hud_main .hud_weap .hud_weap_prev {
  position: relative;
  width: 10vh;
  height: 10vh;
}
.hud_main .hud_weap .hud_weap_prev img {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.hud_main .hud_weap .hud_weap_prev img:first-child {
  transform: scale(0.6) rotate(360deg);
}
.hud_main .hud_weap .hud_weap_ammo {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 0.5vh;
}
.hud_main .hud_weap .hud_weap_ammo h1 {
  color: #FFFFFF;
  font-family: TT Commons;
  font-style: normal;
  font-weight: bold;
  font-size: 2.5vh;
  line-height: 100%;
  margin: 0 0.5vh;
}
.hud_main .hud_weap .hud_weap_ammo h1:last-child {
  opacity: 0.7;
  font-size: 1.5vh;
}
`, "",{"version":3,"sources":["webpack://./src/components/hud/assets/style.less"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,4CAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AACA;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AACJ;AAGA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AADJ;AAXA;EAcQ,WAAA;EACA,kBAAA;EACA,iDAAA;EAGA,YAAA;EAEA,eAAA;EACA,gBAAA;AAHR;AAnBA;EA4BQ,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANR;AA3BA;EAmCY,YAAA;AALZ;AA9BA;EAsCY,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,iDAAA;AALZ;AA5CA;EAoDY,kBAAA;EACA,kBAAA;EAEA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,iDAAA;EAEA,kBAAA;AARZ;AAzDA;EAoEY,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;AARZ;AAlEA;EA4EgB,UAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAPhB;AAzEA;EAoFY,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;AARZ;AAlFA;EA4FgB,UAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAPhB;AAzFA;EAqGY,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2BAAA;AATZ;AAjGA;EA4GgB,aAAA;EACA,UAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AARhB;AAzGA;EAqHY,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;AATZ;AApHA;EA+HgB,aAAA;AARhB;AAvHA;EAiIoB,aAAA;EACA,mBAAA;EACA,uBAAA;AAPpB;AA5HA;EAqIwB,aAAA;EACA,YAAA;EACA,oBAAA;AANxB;AAjIA;EA0IwB,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,4CAAA;AANxB;AA3IA;EAqJoB,kBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AAPpB;AAnJA;EA4JwB,YAAA;EACA,kBAAA;EACA,gCAAA;AANxB;AAxJA;EAoKY,6BAAA;AATZ;AAcA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EAGA,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AAdJ;AAAA;EAiBQ,WAAA;EACA,kBAAA;EACA,+EAAA;EACA,YAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAdR;AATA;EA6BQ,gBAAA;EACA,iBAAA;EACA,eAAA;AAjBR;AAdA;EAkCY,WAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAjBZ;AArBA;EAwCgB,WAAA;EACA,yDAAA;AAhBhB;AAmBY;EACI;IACI,aAAA;EAjBlB;AACF;AA9BA;EAoDY,iBAAA;EACA,aAAA;EACA,yBAAA;AAnBZ;AAnCA;EAwDgB,WAAA;AAlBhB;AAtCA;EA4DY,eAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAnBZ;AA5CA;EAiEgB,aAAA;EACA,mBAAA;AAlBhB;AAhDA;EAqEgB,cAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAlBhB;AA1DA;EA+EgB,eAAA;EACA,WAAA;EACA,aAAA;EAEA,kBAAA;AAnBhB;AAhEA;EAqFoB,YAAA;EACA,kBAAA;EACA,2BAAA;AAlBpB;AArEA;EA6FY,eAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AArBZ;AA/EA;EAwGY,aAAA;EAEA,WAAA;AAvBZ;AAnFA;EA4GgB,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AAtBhB;AA3FA;EAoHoB,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAtBpB;AAnGA;EA8HoB,aAAA;EACA,kBAAA;AAxBpB;AAvGA;EAiIwB,aAAA;EACA,mBAAA;AAvBxB;AA3GA;EAsIwB,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAxBxB;AAnHA;EAgJgB,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AA1BhB;AA3HA;EAuJoB,WAAA;EACA,mBAAA;AAzBpB;AA/HA;EA6JoB,aAAA;EACA,sBAAA;AA3BpB;AAnIA;EAgKwB,WAAA;EACA,mBAAA;EACA,cAAA;AA1BxB;AAxIA;EAqKwB,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AA1BxB;AA/IA;EA4KwB,aAAA;AA1BxB;AAlJA;EA8K4B,aAAA;EACA,mBAAA;AAzB5B;AAtJA;EAkL4B,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAzB5B;AA9JA;EA+LQ,iBAAA;EACA,WAAA;EACA,kBAAA;AA9BR;AAnKA;EAmMY,kBAAA;EACA,WAAA;EACA,YAAA;AA7BZ;AAxKA;EAuMgB,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA5BhB;AA6BgB;EACI,oCAAA;AA3BpB;AAjLA;EAkNY,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;AA9BZ;AAvLA;EAuNgB,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA7BhB;AA8BgB;EACI,YAAA;EACA,gBAAA;AA5BpB","sourcesContent":["@font-face {\n    font-family: 'Chakra'; \n    src: url( ./../../../assets/fonts/Chakra/ChakraPetch-Bold.ttf);  \n    font-weight: 600;\n    font-style: normal;\n}\n.hud_prbar {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n    user-select: none;\n}\n\n\n.hud_sp {\n    display: flex;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    justify-content: flex-end;\n    align-items: flex-end;\n    width: 50vh;\n    height: 50vh;\n    overflow: hidden;\n    z-index: -1;\n    user-select: none;\n    pointer-events: none;\n    .hud_bg {\n        z-index: -1;\n        position: absolute;\n        background: radial-gradient(#060a103f, #ffffff00);\n//        border-radius: 10vh;\n//        background: radial-gradient(100% 100% at 100% 100%, #060A10 0%, #ffffff00 100%);\n        opacity: 0.2;\n//        transform: matrix(1, 0, 0, -1, 0, 0);\n        min-width: 30vh;\n        min-height: 30vh;\n//        margin-bottom: 10vh;\n//        right: -1.5vh;\n//        bottom: -8vh;\n    }\n    .hud_circle {\n        position: absolute;\n        width: 30vh;\n        height: 30vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        .RCP__track   {\n            opacity: 0.5;\n        }\n        h1 {\n            margin-top: -2vh;\n            position: absolute;\n            text-align: center;\n            display: flex;\n            color: #fff;\n            font-family: Chakra;\n            font-style: normal;\n            font-weight: bold;\n            font-size: 5.0vh;\n            line-height: 100%;\n            transition: all 1.0s ease;\n            background: radial-gradient(#060a100f, #ffffff00);\n        }\n        h2 {\n            position: absolute;\n            text-align: center;\n//            padding-top: 7vh;\n            display: flex;\n            color: #ffffffbb;\n            font-family: TT Commons;\n            font-style: normal;\n            font-weight: bold;\n            font-size: 1.5vh;\n//            line-height: 100%;\n            transition: all 1.0s ease;\n            background: radial-gradient(#060a100f, #ffffff00);\n//            height: 1vh;\n            margin-top: -7.9vh;\n        }\n        .hud_s_data_left {\n            position: absolute;\n            margin-right: 23vh;\n            margin-top: 23vh;\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            transition: all 1s ease-out;\n            img {\n                width: 2vh;\n                background-color: rgba(84, 255, 84, 0.172);\n                padding: 0.5vh;\n                border-radius: 2vh;\n                opacity: 0.3;\n            }\n        }\n        .hud_s_data_right {\n            position: absolute;\n            margin-right: -23vh;\n            margin-top: 23vh;\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            transition: all 1s ease-out;\n            img {\n                width: 2vh;\n                background-color: rgba(248, 142, 61, 0.172);\n                padding: 0.5vh;\n                border-radius: 2vh;\n                opacity: 0.3;\n            }\n        }\n\n        .hud_s_data {\n            position: absolute;\n            margin-top: 23vh;\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            transition: all 1s ease-out;\n            img {\n                margin: 0.5vh;\n                width: 2vh;\n                background-color: rgba(84, 255, 84, 0.172);\n                padding: 0.5vh;\n                border-radius: 2vh;\n                opacity: 0.3;\n            }\n        }\n        .hud_status_stack {\n            position: absolute;\n            margin-top: 8.9vh;\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            flex-direction: column;\n            gap: 0.65vh;\n            width: 100%;\n            left: 0;\n            .hud_status_bar {\n                width: 14.5vh;\n                .hud_status_head {\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    img {\n                        width: 1.45vh;\n                        opacity: 0.9;\n                        margin-right: 0.55vh;\n                    }\n                    span {\n                        color: #ffffef;\n                        font-family: Chakra;\n                        font-style: normal;\n                        font-weight: bold;\n                        font-size: 1.45vh;\n                        line-height: 100%;\n                        letter-spacing: 0.02vh;\n                        text-shadow: 0 0 0.8vh rgba(6, 10, 16, 0.42);\n                    }\n                }\n                .hud_status_track {\n                    margin-top: 0.35vh;\n                    width: 100%;\n                    height: 0.64vh;\n                    border-radius: 1vh;\n                    background: rgba(255, 255, 255, 0.2);\n                    overflow: hidden;\n                    div {\n                        height: 100%;\n                        border-radius: 1vh;\n                        transition: width 0.35s ease-out;\n                    }\n                }\n            }\n        }\n        .RCP {\n            position: absolute !important;\n        }\n\n    }\n}\n.hud_main {\n    display: flex;\n    position: absolute;\n    right: 0;\n    top: 0;\n//    margin-top: 1vh;\n//    margin-right: 1.5vh;\n    justify-content: flex-end;\n    align-items: flex-start;\n    width: 45vh;\n    height: 40vh;\n    overflow: hidden;\n    z-index: -1;\n    user-select: none;\n    pointer-events: none;\n\n    .hud_bg {\n        z-index: -1;\n        position: absolute;\n        background: radial-gradient(100% 100% at 100% 100%, #060A10 0%, #ffffff00 100%);\n        opacity: 0.4;\n        transform: matrix(1, 0, 0, -1, 0, 0);\n        width: 34vh;\n        height: 28vh;\n//        right: -1.5vh;\n//        bottom: -8vh;\n    }\n//    overflow: visible;\n    .hud_data {\n        overflow: hidden;\n        margin-right: 1vh;\n        margin-top: 1vh;\n//        margin-left: 2vh;\n        .hud_sati {\n            height: 4vh;\n            margin-top: 1.5vh;\n            display: flex;\n            justify-content: flex-end;\n            align-items: center;\n            img {\n                height: 3vh;\n                animation:  .5s linear 15s infinite alternate sati_frames;\n            }\n\n            @keyframes sati_frames {\n                100% {\n                    height: 3.2vh;\n                }\n              }\n\n        }\n        .hud_star {\n            margin-top: 1.5vh;\n            display: flex;\n            justify-content: flex-end;\n            img {\n                height: 2vh;\n            }\n        }\n        .hud_bar {\n            margin-top: 1vh;\n            display: flex;\n            justify-content: flex-end;\n            align-items: center;\n            img {\n                height: 1.5vh;\n                margin-right: 0.5vh;\n            }\n            h1 {\n                min-width: 2.0vh;\n                color: #FFFFFF;\n                font-family: TT Commons;\n                font-style: normal;\n                font-weight: bold;\n                font-size: 1.3vh;\n                line-height: 100%;\n                text-align: end;\n            }   \n            .hud_hp {\n                margin: 0 0.5vh;\n                width: 12vh;\n                height: 1.1vh;\n//                opacity: 0.4;\n                border-radius: 1vh;\n                div {\n                    height: 100%;\n                    border-radius: 1vh;\n                    transition: all 1s ease-out;\n                }\n            }\n        }\n\n        .hud_money {\n            margin-top: 1vh;\n            color: #fafff8;\n            font-family: TT Commons;\n            font-style: normal;\n            font-weight: bold;\n            font-size: 3.0vh;\n            line-height: 100%;\n            text-align: end;\n//            padding: 0 0.8vh;\n        }\n        .hud_server {\n            display: flex;\n//            width: 20vh;\n            height: 5vh;\n            .hud_time {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: flex-end;\n                height: 5vh;\n                min-width: 5.5vh;\n//                padding: 0.8vh;\n                h1 {\n                    color: #FFFFFF;\n                    font-family: TT Commons;\n                    font-style: normal;\n                    font-weight: bold;\n                    font-size: 1.8vh;\n                    line-height: 100%;\n//                    padding-top: 0.5vh;\n                }     \n                div {\n//                    top: 1vh;\n                    display: flex;\n                    padding-top: 0.5vh;\n                    img {\n                        height: 1.3vh;\n                        margin-right: 0.5vh;\n                    }\n                    h1 {\n//                        padding: 0;\n                        color: #FFFFFF;\n                        font-family: TT Commons;\n                        font-style: normal;\n                        font-weight: bold;\n                        font-size: 1.7vh;\n                        line-height: 100%;\n                    }\n                }           \n            }\n            .hud_server_left {\n                display: flex;\n                justify-content: center;\n                align-items: flex-start;\n                height: 5vh;\n                position: relative;\n                margin-right: 2vh;\n                img {\n                    height: 5vh;\n                    margin-right: 0.3vh;\n                }\n                .hud_server_center{\n//                    margin-left: 1vw;\n//                    padding: 0.8vh;\n                    display: flex;\n                    flex-direction: column;\n                    h1 {\n                        color: #fff;\n                        font-family: Chakra;\n                        font-size: 2.0vh;\n                    }\n                    h2 {\n                        font-family: Chakra;\n                        font-style: normal;\n                        font-weight: 800;\n                        font-size: 2.0vh;\n                        line-height: 100%;\n                    }\n                    div {\n                        display: flex;\n                        img {\n                            height: 1.3vh;\n                            margin-right: 0.5vh;\n                        }\n                        h1 {\n                            color: #FFFFFF;\n                            font-family: TT Commons;\n                            font-style: normal;\n                            font-weight: bold;\n                            font-size: 1.7vh;\n                            line-height: 100%;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .hud_weap {\n        margin-top: 6.5vh;\n        right: 20vh;\n        position: absolute;\n        .hud_weap_prev {\n            position: relative;\n            width: 10vh;\n            height: 10vh;\n            img {\n                position: absolute;\n                width: 100%;\n                height: 100%;\n                overflow: hidden;\n                &:first-child {\n                    transform: scale(0.6) rotate(360deg);\n                }\n            }\n        }\n        .hud_weap_ammo {\n//            position: absolute;\n            display: flex;\n            justify-content: center;\n            align-items: flex-start;\n            margin-top: 0.5vh;\n            h1 {\n                color: #FFFFFF;\n                font-family: TT Commons;\n                font-style: normal;\n                font-weight: bold;\n                font-size: 2.5vh;\n                line-height: 100%;\n                margin: 0 0.5vh;\n                &:last-child {\n                    opacity: 0.7;\n                    font-size: 1.5vh;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
